export function itemTitle(item) {
  return `${item.product?.name ?? ''}${item.serial_number ? ` (${item.serial_number})` : ''}`;
}

export function truncate(text, length = 50, suffix = '...') {
  if (text.length > length) {
    return `${text.substring(0, length)}${suffix}`;
  } else {
    return text;
  }
}

export function vehicleTitle(vehicle) {
  return [vehicle.make, vehicle.model, vehicle.registration, vehicle.vin].filter(p => !!p).join(' - ');
}

export function plural(unit, value) {
  return value === 1 ? unit : `${unit}s`;
}

export function trialSummary(trialable) {
  if (trialable?.trial_length && trialable?.trial_unit) {
    switch (trialable.trial_unit) {
      case 'days':
        return `${trialable.trial_length} ${plural('day', trialable.trial_length)}`;
      case 'weeks':
        return `${trialable.trial_length} ${plural('week', trialable.trial_length)}`;
      case 'months':
        return `${trialable.trial_length} ${plural('month', trialable.trial_length)}`;
      default:
        break;
    }
  }
  return '-';
}
